module.exports = __webpack_public_path__ + "static/media/newVisa.673cd175.svg";